export enum TextCssClass {
  RendererText2d = 'renderer-text-2d',
  RendererText3d = 'renderer-text-3d',
  Text2d = 'text-2d',
  Text3d = 'text-3d'
}
